export const UPDATE_DIMENSION = {
    REQUEST: 'PACKAGE.FORM_PACKAGE_DIMENSION.UPDATE_DIMENSION.REQUEST',
    SUCCESS: 'PACKAGE.FORM_PACKAGE_DIMENSION.UPDATE_DIMENSION.SUCCESS',
    FAILED: 'PACKAGE.FORM_PACKAGE_DIMENSION.UPDATE_DIMENSION.FAILED',
};

export const RESET_ERROR = 'PACKAGE.FORM_PACKAGE_DIMENSION.RESET_ERROR';

export const CLEAR_STATE = 'PACKAGE.FORM_PACKAGE_DIMENSION.CLEAR_STATE';
